angular.module('bb.listing.open_houses').config(OpenHouseConfig);
OpenHouseConfig.$inject = ['$routeProvider'];

function OpenHouseConfig($routeProvider) {
  $routeProvider
    .when('/open_houses', {
      template: '<open-houses-list />',
    })
    .when('/open_houses/add', {
      template: '<open-houses-add />',
    });
}

export {};
